import { roadmapVisibilityConditionsSchema } from "src/stores/models/roadmap-visibility-conditions";
import { InferType, array, boolean, date, number, object, string } from "yup";

const disabledTargetSchema = object({
  id: string().uuid().required(),
});

export const roadmapCardSchema = object({
  id: string().uuid().required(),
  title: string().required(),
  cardKey: string().required(),
  order: number().nullable().optional(),
  enabled: boolean().required(),
  description: string().required(),
  parentStageKey: string().required(),
  helpCenterArticleId: string().nullable().optional(),
  visibilityConditions: roadmapVisibilityConditionsSchema.nullable().optional(),
  disabledForOrganizations: array().of(disabledTargetSchema).optional(),
  disabledForDevices: array().of(disabledTargetSchema).optional(),
  organizationId: string().uuid().nullable().optional(),
  deviceId: string().uuid().nullable().optional(),
  createdAt: date().required(),
  updatedAt: date().required(),
});

export type RoadmapCard = InferType<typeof roadmapCardSchema>;

export const roadmapCardsSchema = array().of(roadmapCardSchema);

export type RoadmapCards = InferType<typeof roadmapCardsSchema>;

export const HARDCODED_CARDS = {
  PURCHASING_SALES_AND_SUPPLIERS: "purchasing-sales-and-suppliers",
  ESTABLISH_QUALITY_MANAGEMENT_SYSTEM: "establish-quality-management-system",
  COMPUTER_SYSTEM_VALIDATION: "computer-system-validation",
  TRAINING: "training",
  AUDITS_AND_REVIEW: "audits-and-review",
  DEVICE_BASIC_CHARACTERISTICS: "device-basic-characteristics",
  DESIGN_AND_DEVELOPMENT_PLANS: "design-and-development-plans",
  USER_NEEDS: "user-needs",
  RISK_MANAGEMENT: "risk-management",
};
